import React from 'react'
import RocketIcon from 'components/Common/SvgIcons/RocketIcon'
import ToolsGuideCard from 'components/Owner/Tools/ToolsGuideCard'
import { ToolsGuideWrapper } from 'components/Owner/Tools/style'
import RocketTopIcon from 'components/Common/SvgIcons/RocketTopIcon'
import ToolsGuideCardChild from 'components/Owner/Tools/ToolsGuideCardChild'

const ToolsGuide = ({ updateOwnerProfile }) => {
  return (
    <ToolsGuideWrapper>
      <ToolsGuideCard
        key="new-guide"
        description={['Take assessments and get ', <br />, 'recommendations.']}
      >
        <ToolsGuideCardChild
          Icon={RocketIcon}
          description={'I am new to using small business software with my business.'}
          updateOwnerProfile={updateOwnerProfile}
          type="new"
        />
      </ToolsGuideCard>
      <ToolsGuideCard
        key="existing-guide"
        description={['Connect the tools I already use ', <br />, 'with my business.']}
      >
        <ToolsGuideCardChild
          Icon={RocketTopIcon}
          description={
            'I am experienced in using technology tools for my business, and I want to get started.'
          }
          updateOwnerProfile={updateOwnerProfile}
          type="experience"
        />
      </ToolsGuideCard>
    </ToolsGuideWrapper>
  )
}

export default ToolsGuide
